import { Transaction } from '@/api/general';
import { findTransactionStatus } from '@/helpers/findTransactionStatus';

const UNLINKABLE_STATUSES = ['rejected', 'declined'];

// linking looks up payment instructions by the transaction's card, so only card
// transactions that went through and have no payment instruction yet can be linked
export const canLinkPayment = (transaction: Transaction) =>
    transaction.type === 'card' &&
    !transaction.paymentId &&
    !UNLINKABLE_STATUSES.includes(findTransactionStatus(transaction));
